import React from "react";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MuiSelect from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

export interface Option {
  value: string;
  label: string;
}

interface SelectProps {
  options: Option[];
  value?: string;
  onChange?: (value: string) => void;

  disabled?: boolean;
  className?: string;
}

const Select: React.FC<SelectProps> = ({
  options,
  value = "",
  onChange,

  disabled = false,
  className = "",
}) => {
  const labelId = `select-label-${Math.random().toString(36).slice(2, 9)}`;

  return (
    <FormControl fullWidth size="small" className={className}>
      <MuiSelect
        labelId={labelId}
        value={value}
        onChange={(e) => onChange && onChange(e.target.value as string)}
        disabled={disabled}
      >
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </MuiSelect>
    </FormControl>
  );
};

export default Select;
